export type TrekPackagesApiDeparture = {
  dates?: string;
  availability?: string | null;
  spacesAvailable?: string | null;
  limitedAvailability?: string | null;
};

export type TrekPackagesApiPrice = {
  id?: string | number;
  trek_code?: string;
  trek_route?: string;
  trek_title?: string;
  trek_price?: string | null;
  trek_person_day?: string | null;
  availability?: string | null;
  dates?: string | null;
  datesAvailability?: TrekPackagesApiDeparture[];
};

export type TrekPackagesApiPackage = {
  id?: string | number;
  trek_code?: string;
  trek_route?: string;
  trek_title?: string;
  trek_type?: string | null;
  trek_direction?: string | null;
  trek_grade?: string | null;
  trek_details?: string | null;
  trek_link?: string | null;
  trek_tags?: string | null;
  trek_image?: { url?: string; alt?: string } | null;
  sort_order?: number;
};

export type TrekPackagesApiYear = {
  year: number;
  label: string;
  sort_order: number;
  is_published: boolean;
  prices: TrekPackagesApiPrice[];
};

export type TrekPackagesApiPayload = {
  trekPackagesList: TrekPackagesApiPackage[];
  years: TrekPackagesApiYear[];
  setYear1: string | null;
  setYear2: string | null;
  setYear3: string | null;
  trekprices1: TrekPackagesApiPrice[];
  trekprices2: TrekPackagesApiPrice[];
  trekprices3: TrekPackagesApiPrice[];
};

/**
 * Fetch trek packages from enquiries (via local Nitro proxy).
 * Pass trek route title to filter (same as AppTrekPackages trekTitle prop).
 */
export async function fetchTrekPackagesApi(route?: string | null) {
  return await $fetch<TrekPackagesApiPayload>("/api/trek-packages-api", {
    query: route ? { route } : undefined,
  });
}

export function useTrekPackagesApi(trekTitle: MaybeRefOrGetter<string>) {
  const title = computed(() => toValue(trekTitle));
  return useAsyncData(
    () => `trek-packages-api:${title.value || "all"}`,
    () => fetchTrekPackagesApi(title.value || undefined),
    { watch: [title] },
  );
}
